/** @format */
import { desktop } from '@mpb-com/feather/helpers/media-queries';
import styled, { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { ProductComparisonItemStyleProps } from './types';

const borderStyle = `1px solid var(--colors-border-light)`;

export const ProductComparisonItemHeader = styled.header<ProductComparisonItemStyleProps>`
    grid-column-start: ${({ $columnIndex }) => $columnIndex + 2};
    display: grid;
    gap: var(--layout-spacing-12);
    padding: var(--layout-spacing-16) var(--layout-spacing-12);
    align-items: center;
    border-bottom: ${borderStyle};
    border-right: ${borderStyle};
`;

export const ProductComparisonItemSection = styled.div<ProductComparisonItemStyleProps>`
    grid-column-start: ${({ $columnIndex }) => $columnIndex + 2};
    padding: var(--layout-spacing-8) var(--layout-spacing-12);
    background: ${({ $rowIndex }) =>
        $rowIndex % 2
            ? 'var(--colors-surface-primary)'
            : 'var(--colors-surface-secondary)'};
    border-bottom: ${borderStyle};
    border-right: ${borderStyle};
    ${theme.typography.body_small};

    ${({ $isInStock }) =>
        !$isInStock &&
        css`
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
        `}

    strong {
        display: block;
    }

    ul {
        margin: 0;
        padding-left: 0;
        list-style: none;
    }

    svg {
        margin-top: 0.1rem;
        font-size: 1.2rem;
    }

    ${desktop(css`
        strong {
            display: none;
        }
    `)}
`;

export const ProductComparisonTableLabel = styled.div`
    ${theme.typography.body_small_highlight}
    margin: 0;
    padding: var(--layout-spacing-8) var(--layout-spacing-12);
    text-align: right;
    border-right: ${borderStyle};
    display: none;

    ${desktop(css`
        display: initial;
    `)}
`;
